import { render, staticRenderFns } from "./guoqi.vue?vue&type=template&id=781af61e&scoped=true"
import script from "./guoqi.vue?vue&type=script&lang=js"
export * from "./guoqi.vue?vue&type=script&lang=js"
import style0 from "./guoqi.vue?vue&type=style&index=0&id=781af61e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781af61e",
  null
  
)

export default component.exports